import { EventEmitter, Inject } from '@angular/core';
import { CURRENT_PREVIEW_FILE } from './current-preview-file';
import { FileEntry } from '../uploads/file-entry';
import { Settings } from '../core/config/settings.service';
import { Observable } from 'rxjs';
import { AppHttpClient } from '../core/http/app-http-client.service';
import { DomSanitizer, SafeResourceUrl, Title, Meta } from '@angular/platform-browser';
import { CurrentUser } from '../auth/current-user';
import { DownloadItemService } from '../downloads/download-item.service';
import { ClipboardService } from 'ngx-clipboard';
import { FormBuilder } from '@angular/forms';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { icons } from './icons'
import { NgxSpinnerService } from 'ngx-spinner';
import { TrackingService } from '../tracking/tracking.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Angulartics2 } from 'angulartics2';

export abstract class BaseFilePreview {
    public download = new EventEmitter();

    constructor(
        @Inject(CURRENT_PREVIEW_FILE) protected file: FileEntry,
        protected settings: Settings,
        protected http: AppHttpClient,
        protected sanitizer: DomSanitizer,
        protected currentUser: CurrentUser,
        protected downloadItemService: DownloadItemService,
        protected titleService: Title,
        protected clipboardService: ClipboardService,
        protected formBuilder: FormBuilder,
        protected library: FaIconLibrary,
        protected spinner: NgxSpinnerService,
        protected trackingService: TrackingService,
        protected deviceService: DeviceDetectorService,
        protected meta: Meta,
        protected angulartics2: Angulartics2
    ) {
        library.addIcons(...icons)
    }

    public getSrc(): string {
        return this.settings.getBaseUrl() + this.file.url;
    }

    public getSafeSrc(): SafeResourceUrl {
        return this.sanitizer.bypassSecurityTrustResourceUrl(this.getSrc());
    }

    public getContents(): Observable<string> {
        return this.http.get(this.getSrc(), null, {responseType: 'text'});
    }

    public showPreloader(duration: number): Promise<void> {
        return new Promise((resolve, reject) => {
            this.spinner.show()

            setTimeout(() => {
                this.spinner.hide()
                resolve()
            }, duration)
        })
    }
}
